import classNames from 'classnames';
import React, { MutableRefObject } from 'react';
import { type Swiper as SwiperType } from 'swiper';
import { Mousewheel } from 'swiper/modules';
import { Swiper } from 'swiper/react';
import Button from '@/components/molecules/button/button';
import useSwiperState from '@/libraries/hooks/use-swiper-state';
import styles from './swipe-items.module.scss';

export interface SwipeItemsProps {
  /** The children to render */
  children?: React.ReactNode;
  /** The class name to apply */
  className?: string;
  /** The swiper ref */
  swiperRef: MutableRefObject<SwiperType | undefined>;
}

const SwipeItems = ({ children, className, swiperRef }: SwipeItemsProps) => {
  const { isEnd, isBeginning, isOverflowing } = useSwiperState(swiperRef);

  return (
    <Swiper
      className={classNames(styles.component, className, {
        [styles.hasPrevious]: !isBeginning && isOverflowing,
        [styles.hasNext]: !isEnd && isOverflowing,
      })}
      modules={[Mousewheel]}
      mousewheel
      onSwiper={swiper => {
        swiperRef.current = swiper;
      }}
      slidesPerView="auto"
      wrapperClass={styles.wrapper}
    >
      {!isBeginning && isOverflowing && (
        <Button
          className={styles.slidePrevious}
          icon="ChevronLeft"
          onClick={() => swiperRef.current?.slidePrev()}
          variant="tertiary"
        />
      )}

      {children && children}

      {!isEnd && isOverflowing && (
        <Button
          className={styles.slideNext}
          icon="ChevronRight"
          onClick={() => swiperRef.current?.slideNext()}
          variant="tertiary"
        />
      )}
    </Swiper>
  );
};

SwipeItems.displayName = 'SwipeItems';

export default SwipeItems;
